import { createAsyncThunk } from '@reduxjs/toolkit';
import type { HttpError } from '@wix/yoshi-flow-bm';
import { getUserConnectStatus } from '@wix/ambassador-adsense-v1-adsense-user/http';
import {
  ConnectStatus,
  type GetUserConnectStatusResponse,
} from '@wix/ambassador-adsense-v1-adsense-user/types';
import settingsParams from '@app/settingsParams';
import type { StoreExtraArgs } from '../../../types';

export const fetchUserConnectStatus = createAsyncThunk(
  'fetchUserConnectStatus/GET',
  async (
    _,
    { extra, rejectWithValue },
  ): Promise<GetUserConnectStatusResponse> => {
    const { httpClient, wixSdk, settings } = extra as StoreExtraArgs;
    try {
      const instanceId = wixSdk.getInstanceId();

      const { data } = await httpClient.request(
        getUserConnectStatus({ instanceId }),
      );

      const connectStatus =
        data.adsenseUser?.user?.adsenseInfo?.connectStatus ??
        ConnectStatus.DISCONNECTED;
      settings.set(settingsParams.connectStatus, connectStatus);

      return data;
    } catch (e) {
      const error = e as HttpError;
      const message = error.response?.data?.message || error.message;
      throw rejectWithValue(message);
    }
  },
);
